// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__pjniI","loader":"style_loader__hD59r","spinner":"style_spinner__uRxoY"};